import * as App from '../../../../app';
import { CANVAS_SCALE } from '../../../../lib/classes';
import { roundRect } from '../../../../lib/utils';
import { hexToRgbaMemoized } from '../../../../lib/MediumColor/hexToRgba';
// console.log(hexToRgba('#2e4088', '0.25')) // rgba(46,64,136,0.25)
export function drawGrid(canvas, cellSize, gridPos) {
    var _a = App.themes.get(), name = _a.name, gridBg1 = _a.gridBg1, gridBg2 = _a.gridBg2;
    if (name === 'old-school') {
        var gridBg = IS_ULTRA ? 'rgba(46,64,136,0.25)' : '#e4e9ef';
        var gridBorder = IS_ULTRA ? '#2d2e4a' : '#565f75';
        var bigCellSize = cellSize * 3;
        var lineWidth = CANVAS_SCALE > 1 ? 2 : 1;
        for (var y = 0; y < 9; y += 3) {
            for (var x = 0; x < 9; x += 3) {
                var xi = gridPos.x + x * cellSize;
                var yi = gridPos.y + y * cellSize;
                if ((x === 3 && (y === 0 || y === 6)) || (y === 3 && (x === 0 || x === 6))) {
                    canvas.fillRect(xi, yi, bigCellSize, bigCellSize, gridBg);
                }
                canvas.strokeRect(xi, yi, bigCellSize, bigCellSize, gridBorder, lineWidth);
            }
        }
        var cellBorderColor = hexToRgbaMemoized(gridBorder, '0.5');
        for (var y = 0; y < 9; y += 1) {
            for (var x = 0; x < 9; x += 1) {
                var xi = gridPos.x + x * cellSize;
                var yi = gridPos.y + y * cellSize;
                canvas.strokeRect(xi, yi, cellSize, cellSize, cellBorderColor);
            }
        }
    }
    else {
        var wh = cellSize - 2;
        var r = Math.ceil(wh * (name === 'default' ? 0.05 : 0.15));
        for (var y = 0; y < 9; y += 1) {
            for (var x = 0; x < 9; x += 1) {
                var topBottom = x >= 3 && x < 6 && (y < 3 || y >= 6);
                var leftRight = (x < 3 || x >= 6) && y >= 3 && y < 6;
                var color = topBottom || leftRight ? gridBg2 : gridBg1;
                var xi = gridPos.x + x * cellSize + 1;
                var yi = gridPos.y + y * cellSize + 1;
                roundRect(canvas, xi, yi, wh, wh, r, color);
                // roundRect(canvas, xi, yi, wh, wh, r, hexToRgbaMemoized(color, '0.75'))
            }
        }
    }
}
